import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "relative" };
const _hoisted_2 = ["src", "alt"];
import ProjectMainInfoIcons from "@/components/uikit/platformComponents/project/ProjectMainInfoIcons.vue";
import { computed } from "vue";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProjectMainInfoImage',
    setup(__props) {
        const store = useStore();
        const project = computed(() => store.getters["capitals/auCapital"]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(ProjectMainInfoIcons, { project: project.value }, null, 8, ["project"]),
                _createElementVNode("img", {
                    class: "main-info_image",
                    src: project.value.thumb,
                    alt: project.value.thumb
                }, null, 8, _hoisted_2)
            ]));
        };
    }
});
